/**
 * Reorders a 2D widget layout after a drag-and-drop event.
 * Removes rows that become empty after the move.
 *
 * @param {Array<Array>} rows - Current visible rows
 * @param {{ droppableId: string, index: number }} source
 * @param {{ droppableId: string, index: number }} destination
 * @returns {Array<Array>} - New rows
 */
const getRowId = (row) => row.map(w => w.id).join('|');

const reorderLayout = (rows, source, destination) => {
  const sourceRowIndex = rows.findIndex(row => getRowId(row) === source.droppableId);
  const destRowIndex = rows.findIndex(row => getRowId(row) === destination.droppableId);
  if (sourceRowIndex === -1 || destRowIndex === -1) return rows;
  const newRows = rows.map(row => [...row]);

  const [moved] = newRows[sourceRowIndex].splice(source.index, 1);
  newRows[destRowIndex].splice(destination.index, 0, moved);

  return newRows.filter(row => row.length > 0);
};

export default reorderLayout;
